import React from "react";

const DataLoader = () => (
    <div className="table-data-loader">
        <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
        </div>
    </div>
);

export default DataLoader;
